// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"27122":"dd0529764ccfba14","60922":"0ade5379709dbc1f","88390":"1ddc7ae2e620b3c9"}[chunkId] + ".css";
};